module.exports = __webpack_public_path__ + "static/media/CorrugatedImg2.da4b1364.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CorrugatedImg2.JPG
// module id = 1159
// module chunks = 0